export const ACCOUNT_EXTERNAL_METADATA_KEYS = {
    AGENCY_ID: 'AGENCY_ID',
    IS_FLA: 'IS_FLA',
    YAHOO_GEMINI: 'YAHOO_GEMINI',
    YAHOO_MDM: 'YAHOO_MDM',
    YAHOO_DSP_ACCOUNT: 'YAHOO_DSP_ACCOUNT',
    BOOKING_COUNTRY: 'BOOKING_COUNTRY',
    DSP_SEAT_ID: 'DSP_SEAT_ID',
    CATEGORY: 'CATEGORY',
    SUB_CATEGORY: 'SUB_CATEGORY',
    DSP_SEAT_CURRENCY: 'DSP_SEAT_CURRENCY',
    DSP_SEAT_TIMEZONE: 'DSP_SEAT_TIMEZONE',
    YAHOO_NATIVE: 'YAHOO_NATIVE',
    YAHOO_OMNI: 'YAHOO_OMNI',
    SALESFORCE_MDM_ID: 'SALESFORCE_MDM_ID',
    TA_AGENCY_MDM_ID: 'TA_AGENCY_MDM_ID',
    TA_AGENCY_MDM_NAME: 'TA_AGENCY_MDM_NAME',
    TA_AGENCY_PARENT_MDM_ID: 'TA_AGENCY_PARENT_MDM_ID',
    TA_AGENCY_PARENT_MDM_NAME: 'TA_AGENCY_PARENT_MDM_NAME',
    TA_MDM_NAME: 'TA_MDM_NAME',
    TA_VERTICAL: 'TA_VERTICAL',
};

export const CAMPAIGN_EXTERNAL_METADATA_KEYS = {
    YAHOO_GEMINI: 'YAHOO_GEMINI',
    YAHOO_GEMINI_C: 'YAHOO_GEMINI_C',
    UID: 'UID',
};
